import { Box, RadioButtonGroup, ResponsiveContext, Text } from 'grommet';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { sentencecase } from '../utils/string';
import Icon from './Icon';

// With fill, the tabs share the full width and are tall enough to tap
const FillBox = styled(Box)`
    label {
        flex: 1 1 0;
        width: auto;
    }
    label > * {
        flex: 1 1 auto;
    }
`;

const TabToggle = ({options, value, name, onChange, fill=false, iconProps={}, labelProps={}}) => {
    const Wrapper = fill ? FillBox : Box;
    // Tall enough to tap on a phone, as are filled tabs everywhere
    const isPhone = useContext(ResponsiveContext) === 'small';
    const isTall = fill || isPhone;
    return (
        <Wrapper border round="xxsmall">
            <RadioButtonGroup
                name={name}
                direction="row"
                gap="none"
                options={options}
                labelKey="name"
                // Controlled when the caller handles changes, so the highlighted tab is also the
                // checked radio. Form-bound toggles leave the value to the form.
                {...(onChange ? {onChange, value} : {})}
            >
                {(option, { checked, focus, hover }) => {
                    const isLast = options[options.length - 1]?.value === option.value;
                    const isSelected = checked || option.value === value;
                    return (
                        <Box
                            background={isSelected ? 'accent' : undefined}
                            border={!isLast ? {side: 'right', color: 'border'} : undefined}
                            // Tall tabs get wider too, so a short label isn't a narrow, tall box
                            pad={{horizontal: isTall ? '16px' : 'small', vertical: 'xsmall'}}
                            direction="row"
                            gap="small"
                            align="center"
                            justify="center"
                            width="100%"
                            {...(isTall ? {height: {min: '44px'}} : {})}
                        >
                            {option?.icon ?
                                (<Icon SelectedIcon={option?.icon} size="xsmall" {...iconProps}/>) :
                                ('')}
                            <Text {...labelProps}>{sentencecase(option?.name)}</Text>
                        </Box>
                    );
                }}
            </RadioButtonGroup>
        </Wrapper>
    )
}

export default TabToggle;